module.exports = __webpack_public_path__ + "static/media/banner.9ad55ba7.png";